import { User } from '../reducer'

export const checkIsBusinessUser = ({ isBusinessUser = false, organisationId }: User): boolean =>
  isBusinessUser || !!organisationId
